// extracted by mini-css-extract-plugin
export default {"nickName_settings_footer":"tH_tI","nickName_settings_footer_mobileEdit":"tH_tJ"};